import React, { useState } from 'react';
import { Attachment } from 'presentation/components/Queue/Chat/Chat';
import AttachmentIcon from 'presentation/components/Queue/CMComposer/Attachments/AttachmentItem/AttachemntItemIcon';
import MobileAttachmentModal from '../MobileAttachmentModal/MobileAttachmentModal';
import './MobileMessageAttachments.scss';

type MobileMessageAttachmentsProps = {
  attachments: Attachment[];
};

export const getAttachmentType = (attachment: Attachment) => {
  const { filename } = attachment;
  const extension = filename.split('.').pop()?.toLowerCase();
  return extension;
};

/**
 * Mobile-optimized component for displaying message attachments
 * Uses MobileAttachmentModal for viewing attachments
 */
const MobileMessageAttachments: React.FC<MobileMessageAttachmentsProps> = ({ attachments }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const attachmentsQuantity = attachments.length;

  const handleAttachmentClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  if (!attachmentsQuantity) {
    return null;
  }

  return (
    <>
      <div className="mobile-attachments" onClick={handleAttachmentClick}>
        <div className="mobile-attachments__preview">
          {attachments.map((at, idx) => (
            <div className="mobile-attachments__item" key={`${at.attachmentId}-${idx}`}>
              <i className="mobile-attachments__icon">
                <AttachmentIcon attachamentType={getAttachmentType(at)!} />
              </i>
            </div>
          ))}
        </div>
        <span className="mobile-attachments__count">
          {attachmentsQuantity} Attachment{attachmentsQuantity > 1 ? 's' : ''}
        </span>
      </div>

      <MobileAttachmentModal attachments={attachments} isOpen={isModalOpen} handleClose={handleCloseModal} />
    </>
  );
};

export default MobileMessageAttachments;
